import { useQuery } from '@tanstack/react-query';

import { statsApi } from '../stats.api';

export const useQueryStatsAircrafts = () =>
  useQuery({
    queryKey: ['StatsAircrafts'],
    queryFn: statsApi.getAircraft,
    select: data => data,
  });
